"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorValues2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regeneratorValues.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _ExcelFileUtil = _interopRequireDefault(require("@/views/mixin/ExcelFileUtil"));
var _apolloClient = require("@/apollo/apolloClient");
var _companyMutation = require("@/apollo/mutations/company-mutation");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _companyQuery = require("@/apollo/queries/company-query");
var _checkExt = require("../../utils/check-ext");
var _importMember = require("@/utils/import-member");
var _firebase = _interopRequireDefault(require("firebase"));
var _validate = require("@/utils/validate");
var _auth = require("../../utils/auth");
var strings = _interopRequireWildcard(require("@/utils/strings"));
var _memberImportValidator = require("@/utils/member-import-validator");
var _importFormats = require("@/utils/import-formats");
var _mapToInternal = require("@/utils/import-formats/map-to-internal");
var _dmanagementConverter = require("@/utils/dmanagement-converter");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ExcelUpload',
  mixins: [_ExcelFileUtil.default],
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var validateRequireFileOption = function validateRequireFileOption(rule, value, callback) {
      if (_this.excelFile.length === 0 || _this.excelFile.length === undefined) {
        callback(new Error(rule.colname + 'を選択してください'));
      } else {
        callback();
      }
    };
    return {
      is_error: false,
      excelFile: [],
      uploadExcel: false,
      centerDialogVisible: false,
      noticeDialogVisible: false,
      found: 0,
      updated: 0,
      industries: [],
      users: [],
      user_affiliations: [],
      rules: {
        excelFile: [{
          required: true,
          validator: validateRequireFileOption,
          colname: '添付ファイル'
        }]
      },
      data: [],
      introduceSample: {
        textProkuShibu: '',
        textShibuChiku: '',
        importSampleName: '',
        exampleName1: '',
        exampleName2: '',
        exampleName3: '',
        exampleName4: '',
        exampleNumber1: '',
        exampleNumber2: '',
        exampleNumber3: ''
      },
      zoneId: null,
      zoneInfo: {},
      converting: false,
      affiliationKeyword: '',
      selectedAffiliationIds: []
    };
  },
  computed: {
    selectedAffiliationText: function selectedAffiliationText() {
      if (!this.selectedAffiliationIds.length) return '';
      return this.selectedAffiliationIds.join(',') + ',';
    },
    groupedSelectedAffiliations: function groupedSelectedAffiliations() {
      var nodeMap = {};
      var _buildMap = function buildMap(nodes) {
        var rootId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var currentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var _iterator = (0, _createForOfIteratorHelper2.default)(nodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var node = _step.value;
            var nodeId = String(node.id);
            var path = [].concat((0, _toConsumableArray2.default)(currentPath), [nodeId]);
            var root = rootId || nodeId;
            nodeMap[nodeId] = {
              rootId: root,
              path: path
            };
            if (node.children && node.children.length) {
              _buildMap(node.children, root, path);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
      _buildMap(this.data);
      var groups = {};
      var groupOrder = [];
      this.selectedAffiliationIds.forEach(function (id) {
        var nodeId = String(id);
        var info = nodeMap[nodeId];
        var rootId = info ? info.rootId : nodeId;
        var path = info ? info.path : [nodeId];
        if (!groups[rootId]) {
          groups[rootId] = {
            parentId: rootId,
            ids: []
          };
          groupOrder.push(rootId);
        }
        groups[rootId].ids.push({
          id: nodeId,
          path: path,
          depth: path.length - 1
        });
      });
      var grouped = groupOrder.map(function (rootId) {
        return groups[rootId];
      });
      grouped.forEach(function (group) {
        group.ids.sort(function (a, b) {
          var pathA = a.path;
          var pathB = b.path;
          var minLength = Math.min(pathA.length, pathB.length);
          for (var i = 0; i < minLength; i++) {
            if (pathA[i] !== pathB[i]) {
              return Number(pathA[i]) - Number(pathB[i]);
            }
          }
          return pathA.length - pathB.length;
        });
      });
      return grouped;
    }
  },
  watch: {
    affiliationKeyword: function affiliationKeyword(val) {
      if (this.$refs.affiliationTree) {
        this.$refs.affiliationTree.filter(val);
      }
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var _this2 = this;
      var industries, users, zoneInfo, user_aff, _createDataByElTree, listData, hasChildren;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.introduceSample.textProkuShibu = strings.textChangeByZone().branchMassage;
            this.introduceSample.textShibuChiku = strings.textChangeByZone().areaMessage;
            this.introduceSample.importSampleName = 'import_sample.xlsx';
            this.$store.commit('company/setEnableTextAllSelect', false);
            _context.n = 1;
            return this.$store.dispatch('company/fetchAffiliation');
          case 1:
            _context.n = 2;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.GET_INDUSTRIES
            });
          case 2:
            industries = _context.v;
            this.industries = industries.data.industries;
            // / get User
            _context.n = 3;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.GET_MEMBER_ALL
            });
          case 3:
            users = _context.v;
            this.users = users.data.user;
            // get zone infomation
            if (!(0, _auth.getClaimToken)()) {
              _context.n = 5;
              break;
            }
            this.zoneId = (0, _auth.getClaimToken)().toString().trim();
            _context.n = 4;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.GET_ZONE_INFO,
              variables: {
                zoneID: this.zoneId
              }
            });
          case 4:
            zoneInfo = _context.v;
            this.zoneInfo = zoneInfo.data.zone;
          case 5:
            _context.n = 6;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.USER_AFFILIATION_LIST
            });
          case 6:
            user_aff = _context.v;
            this.user_affiliations = user_aff.data.user_affiliation;
            //
            _createDataByElTree = function createDataByElTree(input) {
              return {
                id: input.id,
                label: input.name,
                children: input.affiliations.map(function (subItem) {
                  return _createDataByElTree(subItem);
                })
              };
            };
            listData = this.$store.getters.affiliations.map(_createDataByElTree);
            this.data = listData;
            if (listData.length) {
              hasChildren = listData.some(function (item) {
                return item.children.length;
              });
              listData.forEach(function (item, index) {
                if (item.children.length && hasChildren) {
                  _this2.introduceSample.exampleName1 = item.label;
                  _this2.introduceSample.exampleName2 = item.children[0].label;
                  _this2.introduceSample.exampleNumber1 = item.children[0].id;
                  if (!_this2.introduceSample.exampleName3) {
                    _this2.introduceSample.exampleName3 = item.label;
                  }
                  _this2.introduceSample.exampleName4 = item.children[0].label;
                  if (!_this2.introduceSample.exampleNumber2) {
                    _this2.introduceSample.exampleNumber2 = item.id;
                  }
                  _this2.introduceSample.exampleNumber3 = item.children[0].id;
                } else {
                  if (index === 0) {
                    _this2.introduceSample.exampleName2 = item.label;
                    _this2.introduceSample.exampleName3 = item.label;
                    _this2.introduceSample.exampleNumber1 = item.id;
                    _this2.introduceSample.exampleNumber2 = item.id;
                  }
                  if (index === 1) {
                    _this2.introduceSample.exampleName4 = item.label;
                    _this2.introduceSample.exampleNumber3 = item.id;
                  }
                }
              });
            }
            this.validator = new _memberImportValidator.MemberImportValidator({
              industries: this.industries,
              affiliations: this.$store.getters.affiliations
            });
          case 7:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    handleRemoveExcelFile: function handleRemoveExcelFile(file, fileList) {
      this.log('handleRemoveExcelFile');
      this.excelFile = fileList;
    },
    handleAddExcelFile: function handleAddExcelFile(file, fileList) {
      var _this3 = this;
      this.log('handleAddExcelFile');
      if ((0, _checkExt.checkExtExcel)(file.name)) {
        this.excelFile = fileList;
      } else {
        this.excelFile = [];
        this.$refs.upload.clearFiles();
        this.$notify({
          title: 'エラー',
          message: '対応していないファイル形式です',
          type: 'error',
          duration: 0
        });
      }
      this.$nextTick(function () {
        if (_this3.$refs.importForm) {
          _this3.$refs.importForm.validate(function (valid) {});
        }
      });
    },
    removeSelectedFile: function removeSelectedFile() {
      this.excelFile = [];
      this.$refs.upload.clearFiles();
    },
    selectAffiliation: function selectAffiliation(node, treeData) {
      var idsToAdd = [];
      var currentNode = node;
      while (currentNode && currentNode.data) {
        if (currentNode.data.id) {
          idsToAdd.unshift(String(currentNode.data.id));
        }
        currentNode = currentNode.parent;
        if (!currentNode || !currentNode.data) break;
      }
      var current = (0, _toConsumableArray2.default)(this.selectedAffiliationIds);
      idsToAdd.forEach(function (id) {
        if (!current.includes(id)) {
          current.push(id);
        }
      });
      this.selectedAffiliationIds = current;
    },
    filterAffiliationNode: function filterAffiliationNode(value, data) {
      if (!value) return true;
      return data.label.includes(value) || String(data.id).includes(value);
    },
    copySelectedIds: function copySelectedIds() {
      var _this4 = this;
      if (!this.selectedAffiliationText) return;
      navigator.clipboard.writeText(this.selectedAffiliationText).then(function () {
        _this4.$notify({
          title: '情報',
          message: '選択IDをコピーしました。',
          type: 'success',
          duration: 3000
        });
      });
    },
    removeSelectedAffiliation: function removeSelectedAffiliation(id) {
      var targetId = String(id);
      var targetNode = this.findAffiliationNodeById(this.data, targetId);
      if (!targetNode) {
        this.selectedAffiliationIds = this.selectedAffiliationIds.filter(function (v) {
          return v !== targetId;
        });
        return;
      }
      var idsToRemove = this.collectDescendantIds(targetNode);
      idsToRemove.push(targetId);
      this.selectedAffiliationIds = this.selectedAffiliationIds.filter(function (v) {
        return !idsToRemove.includes(String(v));
      });
    },
    findAffiliationNodeById: function findAffiliationNodeById(nodes, targetId) {
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(nodes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          if (String(node.id) === String(targetId)) {
            return node;
          }
          if (node.children && node.children.length) {
            var found = this.findAffiliationNodeById(node.children, targetId);
            if (found) return found;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return null;
    },
    collectDescendantIds: function collectDescendantIds(node) {
      var result = [];
      if (!node.children || !node.children.length) {
        return result;
      }
      var _walk = function walk(children) {
        children.forEach(function (child) {
          result.push(String(child.id));
          if (child.children && child.children.length) {
            _walk(child.children);
          }
        });
      };
      _walk(node.children);
      return result;
    },
    submitUpload: function () {
      var _submitUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _this5 = this;
        var rawMembers, headers, format, members, objects, updateObjects, line_no, objectAffiliation, isErrorUserDeleteAffiliation, setMembers, noticeOnlyOnce, variables, varDeclarations, mutationFields, batchMutation, users, _loop, index, msg;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.$refs.importForm.validate(function (valid) {
                if (!valid) {
                  return;
                }
                _this5.centerDialogVisible = true;
              });
            case 1:
              if (!(this.centerDialogVisible === false)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              this.log('submitUpload');
              this.uploadExcel = true;
              _context3.n = 3;
              return this.readExcelFileToJson(this.excelFile[0].raw);
            case 3:
              rawMembers = _context3.v;
              if (rawMembers) {
                _context3.n = 4;
                break;
              }
              this.centerDialogVisible = false;
              this.$notify({
                title: 'エラー',
                message: '取り込みファイルが正しくありません。',
                type: 'error',
                duration: 0
              });
              return _context3.a(2);
            case 4:
              if (!(rawMembers.length === 0)) {
                _context3.n = 5;
                break;
              }
              this.centerDialogVisible = false;
              this.$notify({
                title: 'エラー',
                message: '取り込みデータが空です。',
                type: 'error',
                duration: 0
              });
              return _context3.a(2);
            case 5:
              // フォーマット自動検出・内部名変換
              headers = rawMembers.length > 0 ? Object.keys(rawMembers[0]) : [];
              format = (0, _importFormats.detectFormat)(headers);
              if (format) {
                _context3.n = 6;
                break;
              }
              this.centerDialogVisible = false;
              this.$notify({
                title: 'エラー',
                message: 'Excelフォーマットを判別できませんでした。',
                type: 'error',
                duration: 0
              });
              return _context3.a(2);
            case 6:
              this.validator.format = format;
              members = rawMembers.map(function (row) {
                return (0, _mapToInternal.mapToInternal)(row, format);
              });
              objects = [];
              updateObjects = [];
              line_no = 2;
              this.found = 0;
              this.updated = 0;
              objectAffiliation = [];
              isErrorUserDeleteAffiliation = true;
              setMembers = (0, _toConsumableArray2.default)(new Set(members));
              this.is_error = false;
              noticeOnlyOnce = false;
              setMembers.some(function (member) {
                var valueCheck = _this5.validator.validateAffiliationIds(member);
                if (valueCheck && noticeOnlyOnce === false) {
                  _this5.centerDialogVisible = false;
                  _this5.is_error = true;
                  _this5.$notify({
                    title: 'エラー',
                    message: valueCheck + ' (' + line_no + '行目)',
                    type: 'error',
                    duration: 0
                  });
                  noticeOnlyOnce = true;
                  return;
                }
                var memberId = member.memberId != null ? member.memberId.toString().trim() : null;
                var existingUser = memberId ? _this5.users.find(function (item) {
                  return item.id === memberId;
                }) : null;
                var mode = existingUser ? _memberImportValidator.VALIDATION_MODE.EXISTING_USER : _memberImportValidator.VALIDATION_MODE.NEW_USER;
                var result = _this5.validator.validate(member, mode);
                if (result.status === false && noticeOnlyOnce === false) {
                  _this5.centerDialogVisible = false;
                  _this5.is_error = true;
                  _this5.$notify({
                    title: 'エラー',
                    message: result.message + ' (' + line_no + '行目)',
                    type: 'error',
                    duration: 0
                  });
                  noticeOnlyOnce = true;
                  return true;
                }
                line_no++;
                var importMember = new _importMember.ImportMember(member, {
                  zoneInfo: _this5.zoneInfo
                });
                if (!existingUser) {
                  _this5.found++;
                  objects.push(importMember.toNewUserJson());
                } else {
                  if (importMember.hasUpdates(existingUser)) {
                    _this5.updated++;
                    updateObjects.push(importMember.toUpdateJson(existingUser));
                  }
                }
              });
              if (!this.is_error) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2);
            case 7:
              if (!(objects.length > 0)) {
                _context3.n = 8;
                break;
              }
              _context3.n = 8;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.ADD_IMPORT_MEMBER,
                variables: {
                  objects: objects
                }
              }).catch(function (error) {
                _this5.is_error = true;
                _this5.centerDialogVisible = false;
                _this5.$notify({
                  title: 'エラー',
                  message: '会員情報のインポートに失敗しました。',
                  type: 'error',
                  duration: 0
                });
                _this5.log(error);
                return;
              });
            case 8:
              if (!this.is_error) {
                _context3.n = 9;
                break;
              }
              return _context3.a(2);
            case 9:
              if (!(updateObjects.length > 0)) {
                _context3.n = 10;
                break;
              }
              variables = {};
              varDeclarations = [];
              mutationFields = [];
              updateObjects.forEach(function (obj, i) {
                varDeclarations.push('$uid_' + i + ': uuid!', '$user_set_' + i + ': user_set_input!', '$company_id_' + i + ': Int!', '$company_set_' + i + ': company_set_input!');
                mutationFields.push('update_user_' + i + ': update_user(where: {uid: {_eq: $uid_' + i + '}}, _set: $user_set_' + i + ') { affected_rows }', 'update_company_' + i + ': update_company(where: {id: {_eq: $company_id_' + i + '}}, _set: $company_set_' + i + ') { affected_rows }');
                variables['uid_' + i] = obj.uid;
                variables['user_set_' + i] = obj.user_set;
                variables['company_id_' + i] = obj.company_id;
                variables['company_set_' + i] = obj.company_set;
              });
              batchMutation = (0, _graphqlTag.default)('mutation batchUpdateImport(' + varDeclarations.join(', ') + ') { ' + mutationFields.join(' ') + ' }');
              _context3.n = 10;
              return _apolloClient.apolloClient.mutate({
                mutation: batchMutation,
                variables: variables
              }).catch(function (error) {
                _this5.is_error = true;
                _this5.centerDialogVisible = false;
                _this5.$notify({
                  title: 'エラー',
                  message: '会員情報の更新に失敗しました。',
                  type: 'error',
                  duration: 0
                });
                _this5.log(error);
              });
            case 10:
              if (!this.is_error) {
                _context3.n = 11;
                break;
              }
              return _context3.a(2);
            case 11:
              _context3.n = 12;
              return _apolloClient.apolloClient.query({
                query: _companyQuery.GET_MEMBER_ALL
              });
            case 12:
              users = _context3.v;
              this.users = users.data.user;
              _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(index) {
                var isMember, listIdAffilation, _listIdOrganization, pathFromDepth;
                return (0, _regenerator2.default)().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      // uidを取得する
                      isMember = _this5.users.filter(function (item) {
                        return item.id.toString().trim() === members[index].memberId.toString().trim();
                      });
                      if (!(isMember.length !== 0 && isMember)) {
                        _context2.n = 1;
                        break;
                      }
                      listIdAffilation = [];
                      _listIdOrganization = (0, _toConsumableArray2.default)(new Set(members[index].affiliationId.toString().trim().split(','))).filter(function (item) {
                        return item.toString().trim() !== '';
                      });
                      if (!(_listIdOrganization.length !== 0 && _listIdOrganization)) {
                        _context2.n = 1;
                        break;
                      }
                      pathFromDepth = (0, _validate.depthFirstSearch)(_this5.$store.getters.affiliations, _listIdOrganization, false, true);
                      pathFromDepth.forEach(function (item) {
                        listIdAffilation.push(item.id);
                        objectAffiliation.push({
                          affiliation_id: item.id,
                          user_id: isMember[0].uid
                        });
                      });
                      _context2.n = 1;
                      return _apolloClient.apolloClient.mutate({
                        mutation: _companyMutation.USER_AFFILIATION_DELETE,
                        variables: {
                          user_id: isMember[0].uid,
                          affiliation_ids: listIdAffilation
                        }
                      }).catch(function (error) {
                        if (isErrorUserDeleteAffiliation) {
                          _this5.is_error = true;
                          _this5.centerDialogVisible = false;
                          _this5.$notify({
                            title: 'エラー',
                            message: '会員情報のインポートに失敗しました。',
                            type: 'error',
                            duration: 0
                          });
                          _this5.log(error);
                        }
                        isErrorUserDeleteAffiliation = false;
                        return;
                      });
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              index = 0;
            case 13:
              if (!(index < setMembers.length)) {
                _context3.n = 15;
                break;
              }
              return _context3.d((0, _regeneratorValues2.default)(_loop(index)), 14);
            case 14:
              index++;
              _context3.n = 13;
              break;
            case 15:
              _context3.n = 16;
              return _apolloClient.apolloClient.mutate({
                mutation: _companyMutation.USER_AFFILIATION_INSERT,
                variables: {
                  objects: objectAffiliation
                }
              }).catch(function (error) {
                _this5.is_error = true;
                _this5.centerDialogVisible = false;
                _this5.$notify({
                  title: 'エラー',
                  message: '会員情報のインポートに失敗しました。',
                  type: 'error',
                  duration: 0
                });
                _this5.log(error);
                return;
              });
            case 16:
              if (this.is_error === false) {
                this.centerDialogVisible = false;
                this.excelFile = [];
                this.$refs.upload.clearFiles();
                msg = '';
                if (this.found > 0) msg += '新規' + this.found + '件';
                if (this.found > 0 && this.updated > 0) msg += '、';
                if (this.updated > 0) msg += '更新' + this.updated + '件';
                this.$notify({
                  title: '情報',
                  message: msg + 'のインポートが完了しました。',
                  type: 'success',
                  duration: 3000
                });
              }
            case 17:
              return _context3.a(2);
          }
        }, _callee2, this);
      }));
      function submitUpload() {
        return _submitUpload.apply(this, arguments);
      }
      return submitUpload;
    }(),
    selectTxtFile: function selectTxtFile() {
      this.$refs.txtFileInput.value = '';
      this.$refs.txtFileInput.click();
    },
    handleTxtFileSelected: function () {
      var _handleTxtFileSelected = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(event) {
        var files, _t;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              files = event.target.files;
              if (!(!files || files.length === 0)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.converting = true;
              _context4.p = 2;
              _context4.n = 3;
              return (0, _dmanagementConverter.convertDmanagementToExcel)(files[0], this.zoneId);
            case 3:
              this.$notify({
                title: '完了',
                message: 'Excelファイルへの変換が完了しました。ダウンロードされたファイルを取り込み機能でインポートしてください。',
                type: 'success',
                duration: 3000
              });
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              this.$notify({
                title: 'エラー',
                message: _t.message || '変換に失敗しました',
                type: 'error',
                duration: 0
              });
            case 5:
              _context4.p = 5;
              this.converting = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function handleTxtFileSelected(_x) {
        return _handleTxtFileSelected.apply(this, arguments);
      }
      return handleTxtFileSelected;
    }(),
    log: function log(text) {},
    download: function download() {
      // Create a reference to the file we want to download
      var storageRef = _firebase.default.storage().ref().child(strings.textChangeByZone().importSample.toString());
      // Get the download URL
      storageRef.getDownloadURL().then(function (url) {
        var link = document.createElement('a');
        link.href = url;
        link.download = 'import_sample.xlsx';
        link.click();
      }).catch(function (error) {
        switch (error.code) {
          case 'storage/object-not-found':
            break;
          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      });
    }
  }
};